import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
    const location = useLocation();

    useEffect(() => {
        console.error(
            "404 Error: User attempted to access non-existent route:",
            location.pathname
        );
    }, [location.pathname]);

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
            <div className="text-center">
                <h1 className="mb-4 fw-bold display-1">404</h1>
                <p className="mb-4 fs-4">
                    Oops! Page not found
                </p>
                <a href="/" className="text-primary text-decoration-underline">
                    Return to Home
                </a>
            </div>
        </div>
    );
};

export default NotFound;